export const buildingProfileConstants = {
  SEO: {
    title: 'Your Building',
    description: 'Your Building',
  },
};
